export const hidePassword = (text) => text.replace(/./g, "*");
